var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof uk_borrower_platform_flexipay_accounts !== "undefined") return resolve();
	__webpack_require__.l("https://flexipay-accounts.fundingcircle.com/remoteEntry.js?v=1793196028775", (event) => {
		if(typeof uk_borrower_platform_flexipay_accounts !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "uk_borrower_platform_flexipay_accounts");
}).then(() => (uk_borrower_platform_flexipay_accounts));